import { logout, getUserInfo, newlogin } from "@/api/login";
import router from "../../router";
import {
  getToken,
  setToken,
  removeToken,
  setTokenPower,
  removeTokenPower
} from "@/utils/auth";
import { getUrlKey } from "@/utils/index";
const Base64 = require("js-base64").Base64;
const user = {
  state: {
    userId: "",
    userIp: "",
    urlInfo: "",
    status: "",
    systemCode: "",
    token: getToken(),
    name: "",
    nameEn: "",
    actionUrl: [],
    avatar: "",
    introduction: "",
    roles: [],
    setting: {
      articlePlatform: []
    },
    tags: []
  },

  mutations: {
    SET_USERID: (state, userId) => {
      state.userId = userId;
    },
    SET_USERIP: (state, userIp) => {
      state.userIp = userIp;
    },
    SET_SYSTEM_CODE: (state, code) => {
      state.systemCode = code;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_NAME_EN: (state, name) => {
      state.nameEn = name;
    },
    SET_ACTION_URL: (state, actionUrl) => {
      state.actionUrl = actionUrl;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_URL_INFO: (state, urlInfo) => {
      state.urlInfo = urlInfo;
    },
    SET_TAGS: (state, tags) => {
      state.tags = tags;
    }
  },

  actions: {
    // 获取URL信息
    LoginByUsername({ commit }) {
      const code = getUrlKey("code");
      if (code) {
        const urlInfo = JSON.parse(Base64.decode(getUrlKey("code")));
        return new Promise((resolve, reject) => {
          if (urlInfo) {
            setToken(urlInfo.token);
            setTokenPower(JSON.stringify(urlInfo));
            sessionStorage.setItem("urlInfo", JSON.stringify(urlInfo));
            resolve(1);
          } else {
            reject();
          }
        });
      } else {
        return new Promise(resolve => {
          resolve(1);
        });
      }
    },

    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then(response => {
            if (!response.data) {
              reject();
            }
            const data = response.data;
            const urlInfo = JSON.parse(sessionStorage.getItem("urlInfo"));
            commit("SET_URL_INFO", urlInfo);
            commit("SET_USERID", urlInfo.userId);
            commit("SET_USERIP", urlInfo.ip);
            commit("SET_SYSTEM_CODE", urlInfo.systemCode);
            commit("SET_TOKEN", urlInfo.token);
            commit("SET_NAME", data.name);
            commit("SET_NAME_EN", data.englishName);
            commit("SET_ACTION_URL", data.actionUrl);
            const tags = data.userRightVoList.map(i => i.tag).filter(i => i) || [];
            commit("SET_TAGS", tags);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    Login({ commit }, userInfos) {
      const username = userInfos.username.trim();
      return new Promise((resolve, reject) => {
        newlogin(username, userInfos.password)
          .then(response => {
            setToken(response.data.token);
            commit("SET_TOKEN", response.data.token);
            if (response.data.userInfo) {
              // 把登录信息存起来，防止用户手动刷新之后state丢失
              const urlInfo = response.data.userInfo;
              urlInfo.token = response.data.token;
              urlInfo.systemCode = userInfos.systemCode;
              sessionStorage.setItem("urlInfo", JSON.stringify(urlInfo));
              router.push({ path: "/" });
            } else {
              reject();
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_USERID", "");
            commit("SET_USERIP", "");
            commit("SET_SYSTEM_CODE", "");
            commit("SET_TOKEN", "");
            commit("SET_NAME", "");
            commit("SET_NAME_EN", "");
            commit("SET_TAGS", [])
            commit("REMOV_EDEMAN");
            commit("REMOV_TASK");
            commit("REMOV_HOME");
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_USERID", "");
        commit("SET_USERIP", "");
        commit("SET_SYSTEM_CODE", "");
        commit("SET_TOKEN", "");
        commit("SET_NAME", "");
        commit("SET_NAME_EN", "");
        commit("SET_TAGS", [])
        commit("REMOV_EDEMAN");
        commit("REMOV_TASK");
        commit("REMOV_HOME");
        removeTokenPower();
        removeToken();
        resolve();
      });
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit("SET_TOKEN", role);
        setToken(role);
        getUserInfo(role).then(response => {
          const data = response.data;
          commit("SET_ROLES", data.roles);
          commit("SET_NAME", data.name);
          commit("SET_AVATAR", data.avatar);
          commit("SET_INTRODUCTION", data.introduction);
          const tags = data.userRightVoList.map(i => i.tag).filter(i => i) || [];
          commit("SET_TAGS", tags);
          dispatch("GenerateRoutes", data); // 动态修改权限后 重绘侧边菜单
          
          resolve();
        });
      });
    }
  }
};

export default user;
